<template>
  <div>
    <div>
      <h3>Editar dirección del cliente</h3>
    </div>

    <hr class="my-3" />

    <h4>{{ shipToCode }}</h4>

    <div>
      <h5 class="mb-1">Calle *</h5>
      <base-input
        v-model="street"
        maxLength="80"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="Calle"
        class="mb-2"
      />
    </div>

    <div>
      <h5 class="mb-1">Número *</h5>
      <base-input
        v-model="streetNo"
        maxLength="15"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="Número"
        class="mb-2"
      />
    </div>

    <div>
      <h5 class="mb-1">Colonia *</h5>
      <base-input
        v-model="block"
        maxLength="60"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="Colonia"
        class="mb-2"
      />
    </div>

    <div>
      <h5 class="mb-1">Código Postal *</h5>
      <base-input
        v-model="zipCode"
        maxLength="15"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="Código Postal"
        class="mb-2"
      />
    </div>

    <div>
      <h5 class="mb-1">Ciudad *</h5>
      <base-input
        v-model="city"
        maxLength="60"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="Ciudad"
        class="mb-2"
      />
    </div>
    <div>
      <h5 class="mb-1">Estado *</h5>
      <multiselect
        v-model="selState"
        :options="states"
        placeholder="Estado"
        class="mb-2 small-multiselect"
        track-by="code"
        label="name"
        :allow-empty="false"
        :show-labels="false"
      />
    </div>

    <div>
      <h5 class="mb-1">País *</h5>
      <base-input
        v-model="country"
        maxLength="2"
        inputClasses="input-group-alternative form-control-sm text-xs"
        placeholder="País"
        class="mb-2"
      />
    </div>

    <hr class="my-3" />
    <div class="d-flex justify-content-end">
      <base-button @click="$emit('close')" type="secondary" size="sm">
        Cancelar
      </base-button>
      <div v-b-popover.hover.focus.bottom.html="popoverData">
        <base-button
          @click="saveChanges()"
          type="primary"
          size="sm"
          icon="fa fa-check"
          :disabled="!validAddress.valid || saving"
        >
          Guardar cambios
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import states from "@/data/states";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    shipToCode: String,
    customer: Object,
  },
  data() {
    return {
      street: null,
      streetNo: null,
      block: null,
      zipCode: null,
      city: null,
      selState: null,
      country: null,
      states: states,
      saving: false
    };
  },
  methods: {
    async saveChanges() {
      try {
        this.saving = true;

        // Update customer address
        const { CardCode, BPAddresses } = this.customer;
        const newBPAddresses = [];
        BPAddresses.forEach((a) => {
          if (a.AddressName === this.shipToCode && a.AddressType === "bo_ShipTo") {
            a.Street = this.street;
            a.StreetNo = this.streetNo;
            a.Block = this.block;
            a.ZipCode = this.zipCode;
            a.City = this.city;
            a.State = this.selState.code;
            a.Country = this.country;
          }
          newBPAddresses.push(a);
        });
        const bodyCustomer = { BPAddresses: newBPAddresses };
        const resCustomer = await axios.patch(`/api/business_partners?CardCode=${CardCode}`, bodyCustomer)
        if(!resCustomer.data.msg){
          throw new Error("Invalid response");
        }

        this.$swal("Dirección actualizada", "Se ha actualizado la dirección del cliente", 'success');
        this.$emit('success');
        this.$emit('close');

      } catch (e) {
        console.error(e);
        this.$swal("Error", "Error actualizando la dirección en el cliente", 'error');
      } finally {
        this.saving = false;
      }  
    },
  },
  created() {
    const address = this.customer.BPAddresses
      .find((a) => a.AddressName === this.shipToCode && a.AddressType === "bo_ShipTo");

    this.street = address.Street;
    this.streetNo = address.StreetNo;
    this.block = address.Block;
    this.zipCode = address.ZipCode;
    this.city = address.City;
    this.selState = this.states.find((state) => state.code === address.State) ||  null;
    this.country = address.Country;
  },
  computed: {
    validAddress() {
      const { street, streetNo, block, zipCode, city, selState, country } = this;

      const complete = {
        "Calle": street && street.length <= 80,
        "Número": streetNo && streetNo.length <= 15,
        "Colonia": block && block.length <= 60,
        "Código postal": zipCode && zipCode.length <= 15,
        "Ciudad": city && city.length <= 60,
        "Estado": selState && selState.code.length <= 60,
        "País": country && country.length <= 60,
      };
      return {
        valid: Object.values(complete).every((x) => x),
        missing: Object.keys(complete).filter((x) => !complete[x]),
      };
    },
    popoverData() {
      if (this.validAddress.missing.length > 0) {
        return {
          title: "<small><b>Verifica la siguiente información:</b></small>",
          content: `<ul><li>${this.validAddress.missing.join("<li>")}</ul>`,
          placement: "righttop",
        };
      } else {
        return null;
      }
    },
  }
};
</script>

<style lang="scss" scoped></style>
